module.exports = __webpack_public_path__ + "img/Réalisation rampe inox montée.c17b0b46.jpg";